

module.exports = __webpack_require__.stylable.create(
    "description766897990",
    {"classes":{"root":"description766897990__root","container":"description766897990__container","button":"description766897990__button","text":"description766897990__text"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    8,
    "description766897990",
    null
);
